import { EntityService } from './EntityService';
import { IApp03WorkflowStage, IEntityChildren } from '../types';

export class App03WorkflowStageService extends EntityService<IApp03WorkflowStage> {
    private apiURL: string;
    constructor() {
        super(`/App03WorkflowStages`);
        const apiURL = process.env.REACT_APP_ZedX_API!;
        this.apiURL = apiURL;
    }

    public async reorderStage(payload: {
        MovedStageID: number;
        OldIndex?: number;
        NewIndex: number;
        StageCategory: string; // "Backlog" | "Current Stages"
    }): Promise<void> {
        await this.axiosPost(`${this.apiURL}/ReorderStage`, payload);
    }

    public readWorkflowStages(workflowID: number): Promise<IApp03WorkflowStage[]> {
        return this.readAll(
            `?$select=ID,Title,SystemStage`
            + `&$orderby=DisplayOrder`
            + `&$filter=App03WorkflowID eq ${workflowID}`
        );
    }

    public async entityChildren(id: number): Promise<IEntityChildren[]> {

        const entityUrl = `${this.entityUrl}(${id})`;

        const tasks = (
            await this.axiosGet(
                `${entityUrl}/App03Tasks?$select=ID`
            )
        ).data.value;

        return [
            {
                ChildType: 'Tasks',
                CanBeAdopted: false,
                ChildIDs: tasks.map((t: { ID: number }) => t.ID)
            }
        ];
    }
}